import { GraphQLServerUrl, RxDatabase, WithDeleted } from 'rxdb'
import { replicateGraphQL } from 'rxdb/plugins/replication-graphql'

import { graphql } from '@/gql'
import {
  createQueryWithHash,
  pullResponseModifier,
} from '@/system/rxdb/replications/utils.ts'
import { Assignment } from '@/system/rxdb/schemas/assignment.ts'

type PullData =
  | {
      nodes: Array<WithDeleted<Assignment>>
    }
  | { assignment: WithDeleted<Assignment> }

// amount of items we want to pull max for each iteration
const BATCH_SIZE = 20

export const ASSIGNMENT_FRAGMENT = /* GraphQL*/ `
    fragment assignment on Assignment {
        rowId
        appointmentAt
        appUserId
        updatedAt
        deleted
    }
`

export const createAssignmentReplication = (
  db: RxDatabase,
  url: GraphQLServerUrl,
  autoStart: boolean
) => {
  const streamQuery = createQueryWithHash(
    graphql(/* GraphQL */ `
      subscription streamAssignments {
        streamAssignments {
          assignment {
            ...assignment
          }
        }
      }
    `)
  )

  const pullQuery = createQueryWithHash(
    graphql(/* GraphQL */ `
      query assignmentDocuments(
        $checkpoint: DocumentCheckpointInput
        $first: Int!
      ) {
        assignmentDocuments(checkpoint: $checkpoint, first: $first) {
          nodes {
            ...assignment
          }
        }
      }
    `)
  )
  return replicateGraphQL({
    collection: db.assignment,
    url,
    credentials: 'include',
    replicationIdentifier: url.http || '',
    autoStart,
    deletedField: 'deleted',
    pull: {
      includeWsHeaders: true,
      streamQueryBuilder: () => {
        return {
          ...streamQuery,
          variables: {},
        }
      },
      responseModifier: (data: PullData) => {
        // in case of subscriptions, we always only receive a single assignment, so we map it here into the right
        // expected structure
        if (typeof data === 'object' && data && 'assignment' in data) {
          return pullResponseModifier({ nodes: [data.assignment] })
        }
        return pullResponseModifier<Assignment>(
          data as {
            nodes: Array<WithDeleted<Assignment>>
          }
        )
      },
      batchSize: BATCH_SIZE,
      queryBuilder: (checkpoint, limit) => {
        return {
          ...pullQuery,
          variables: {
            checkpoint,
            first: limit,
          },
        }
      },
    },
  })
}
